import React from 'react';
import { Button, Divider, List, Select, Spin, Tooltip, Typography } from 'antd';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons';
import ContactSidebarItem from '../ContactSidebarItem';

const { Text } = Typography;

const SidebarList = ({
    virtualChannels = [],
    selectedChannelId,
    selectedChannel,
    channelsLoading,
    channelOptions = [],
    contacts,
    contactsLoading,
    selectedContactId,
    testConversation,
    conversationByContactId,
    hoveredContactId,
    setHoveredContactId,
    isMobile,
    isDarkMode,
    t,
    onChannelChange,
    onAddChannel,
    onEditChannel = () => { },
    onDeleteChannel = () => { },
    onAddContact,
    onSelectContact,
    onDeleteContact
}) => {
    const listThemeColors = {
        background: isDarkMode ? '#1f1f1f' : '#fff',
        selectedBackground: isDarkMode ? '#183a61' : '#e6f7ff',
        hoverBackground: isDarkMode ? '#2a2a2a' : '#f5f5f5',
        text: isDarkMode ? 'rgba(255, 255, 255, 0.85)' : 'rgba(0, 0, 0, 0.88)',
        secondaryText: isDarkMode ? 'rgba(255, 255, 255, 0.45)' : 'rgba(0, 0, 0, 0.45)'
    };

    return (
        <div className="agent-test-sidebar-list" style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
            <div style={{ padding: isMobile ? '12px 14px' : 8, borderBottom: `1px solid ${isDarkMode ? '#303030' : '#f0f0f0'}` }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 6 }}>
                    <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                        {t('virtual_channel', { defaultValue: 'Virtual channel' })}
                    </Text>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <Tooltip title={t('edit_virtual_channel', { defaultValue: 'Edit virtual channel' })}>
                            <Button
                                aria-label={t('edit_virtual_channel', { defaultValue: 'Edit virtual channel' })}
                                icon={<EditOutlined />}
                                type="text"
                                size="small"
                                disabled={!selectedChannel}
                                onClick={() => onEditChannel(selectedChannel)}
                            />
                        </Tooltip>
                        <Tooltip title={isMobile ? null : t('delete_virtual_channel', { defaultValue: 'Delete virtual channel' })}>
                            <Button
                                aria-label={t('delete_virtual_channel', { defaultValue: 'Delete virtual channel' })}
                                icon={<DeleteOutlined />}
                                type="text"
                                size="small"
                                danger
                                disabled={!selectedChannel}
                                onClick={() => onDeleteChannel(selectedChannel)}
                            />
                        </Tooltip>
                    </div>
                </div>
                <Select
                    value={selectedChannelId}
                    loading={channelsLoading}
                    options={channelOptions}
                    placeholder={t('select_channel', { defaultValue: 'Select channel' })}
                    optionLabelProp="title"
                    onChange={onChannelChange}
                    style={{ width: '100%', marginBottom: 6 }}
                    dropdownRender={(menu) => (
                        <>
                            {menu}
                            <Divider style={{ margin: '8px 0' }} />
                            <Button
                                type="text"
                                icon={<PlusOutlined />}
                                onClick={onAddChannel}
                                block
                            >
                                {t('add_channel', { defaultValue: 'Add channel' })}
                            </Button>
                        </>
                    )}
                />
                {selectedChannel?.description && (
                    <Text
                        type="secondary"
                        title={selectedChannel.description}
                        style={{
                            display: 'block',
                            fontSize: 12,
                            marginBottom: 10,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {selectedChannel.description}
                    </Text>
                )}
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: 8,
                    marginTop: selectedChannel?.description ? 0 : 8,
                }}>
                    <Text
                        strong
                        style={{
                            color: listThemeColors.text,
                            flex: 1,
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {t('contacts')}
                    </Text>
                    <Tooltip title={t('create_virtual_contact', { defaultValue: 'Create virtual contact' })}>
                        <Button
                            aria-label={t('create_virtual_contact', { defaultValue: 'Create virtual contact' })}
                            icon={<PlusOutlined />}
                            type="default"
                            size="small"
                            shape="circle"
                            style={{ flex: '0 0 auto' }}
                            disabled={!virtualChannels.length || !selectedChannelId}
                            onClick={onAddContact}
                        />
                    </Tooltip>
                </div>
            </div>

            {contactsLoading && (
                <div style={{ display: 'flex', justifyContent: 'center', padding: '8px 0' }}>
                    <Spin size="small" />
                </div>
            )}

            <List
                style={{ overflow: 'auto', padding: isMobile ? '4px 0' : '8px 0', background: listThemeColors.background, flex: 1, minHeight: 0 }}
                dataSource={contacts}
                locale={{ emptyText: t('no_contacts') }}
                renderItem={(contact) => {
                    const isActive = contact?.id && contact.id === selectedContactId;
                    const bgColor = isActive
                        ? listThemeColors.selectedBackground
                        : (hoveredContactId === contact?.id ? listThemeColors.hoverBackground : listThemeColors.background);
                    const conversation = isActive
                        ? testConversation
                        : (contact?.id ? conversationByContactId?.[contact.id] : null);

                    return (
                        <ContactSidebarItem
                            contact={contact}
                            conversation={conversation}
                            isActive={isActive}
                            isMobile={isMobile}
                            isDarkMode={isDarkMode}
                            t={t}
                            listThemeColors={listThemeColors}
                            bgColor={bgColor}
                            hoveredContactId={hoveredContactId}
                            setHoveredContactId={setHoveredContactId}
                            onSelect={() => onSelectContact(contact)}
                            onDelete={() => onDeleteContact(contact)}
                        />
                    );
                }}
            />
        </div>
    );
};

export default SidebarList;













